import Landing from "../../components/landing/Landing";
import WebLayout from "../../components/WebLayout";
import BlogInfo from "./blogInfo/BlogInfo";
import axios from "axios";
import { baseUrl, getBlogDetail } from "../../utils/apiData.js";
import { Fragment, useEffect, useState } from "react";
import Loader from "../../components/loader/Loader.jsx";
import { useParams } from "react-router-dom";

const BlogDetail = () => {
 
  const {slug} = useParams();

  const [loader, setLoader] = useState(false);
  const [blog, setBlog] = useState({});

  const getBlogDetailApi = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${getBlogDetail}`, {slug});
      if (res?.data?.success) {
        setBlog(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getBlogDetailApi();
  }, []);

  return (
    <WebLayout>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <Landing title="Blog Detail" from="Home" page="Blog Info" />
          <BlogInfo data={blog} />
        </Fragment>
      )}
    </WebLayout>
  );
};

export default BlogDetail;
